import {
  Button,
  Card,
  CardActions,
  CardContent,
  Typography
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

const useStyles = makeStyles((theme) => ({
  contentEnd: {
    justifyContent: 'end'
  },
  trackInfoTitle: {
    height: "4rem"
  },
  trackInfoDescription: {
    overflow: "auto",
    height: "10rem"
  }
}));

const JobsCardContent = ({ item, onApplyNowClick }) => {
  const classes = useStyles();
  return (
    <>
      <CardContent>
        <div className={classes.trackInfoTitle}>
          <Typography gutterBottom variant="h5" component="div" >
            {item.title}
          </Typography>
        </div>
        <div className={classes.trackInfoDescription}>
          <Typography variant="body2" color="textSecondary" dangerouslySetInnerHTML={{ __html: item.description }} />
        </div>
      </CardContent>
      <CardActions className={classes.contentEnd}>
        <Button
          component="button"
          variant="contained"
          disableRipple
          onClick={() => onApplyNowClick(item)}
          className={"successBtn"}
        >
          Details
        </Button>
      </CardActions>
    </>
  );
};

export default JobsCardContent;
